import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAllSubmissions,
  updateSubmission,
  resetSubmissions,
} from "../utils/submissionUtils";
import { getCurrentUser } from "../utils/auth";
import "../styles/styles.css";

const STATUS_LABEL = {
  pending:  { text: "Pendiente", color: "#f0a500" },
  approved: { text: "Aprobado",  color: "#00c853" },
  rejected: { text: "Rechazado", color: "#ff4444" },
};

const SubmissionsAdmin = () => {
  const navigate = useNavigate();
  const [user]          = useState(() => getCurrentUser());
  const [submissions, setSubmissions] = useState([]);
  const [filter, setFilter]           = useState("all");
  const [expanded, setExpanded]       = useState(null);

  const load = () => setSubmissions(getAllSubmissions());

  useEffect(() => {
    if (!user || user.role !== "admin") {
      navigate("/");
    } else {
      load();
    }
  }, [user, navigate]);

  const handleApprove = (pitch) => {
    updateSubmission(pitch.id, {
      status: "approved",
      comments: "Aprobado. El creador puede subir el contenido completo.",
    });
    load();
  };

  const handleReject = (pitch) => {
    const feedback = window.prompt("Motivo de rechazo o feedback:", "");
    if (feedback !== null) {
      updateSubmission(pitch.id, { status: "rejected", comments: feedback || "No cumple los criterios actuales." });
      load();
    }
  };

  const handleReset = () => {
    if (window.confirm("¿Restaurar los pitches de ejemplo?")) {
      resetSubmissions();
      load();
    }
  };

  const filtered = filter === "all"
    ? submissions
    : submissions.filter((s) => s.status === filter);

  const counts = {
    all:      submissions.length,
    pending:  submissions.filter((s) => s.status === "pending").length,
    approved: submissions.filter((s) => s.status === "approved").length,
    rejected: submissions.filter((s) => s.status === "rejected").length,
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <div>
          <h1 className="admin-title">Panel de Pitches</h1>
          <p className="admin-subtitle">Propuestas enviadas por IA Creators</p>
        </div>
        <button className="btn-small" onClick={handleReset} style={{ opacity: 0.6 }}>
          ↺ Restaurar demo
        </button>
      </div>

      {/* Filtros / Stats */}
      <div className="admin-filter-bar">
        {[
          { key: "all",      label: "Todos" },
          { key: "pending",  label: "⏳ Pendientes" },
          { key: "approved", label: "✅ Aprobados" },
          { key: "rejected", label: "❌ Rechazados" },
        ].map(({ key, label }) => (
          <button
            key={key}
            className={`admin-filter-btn ${filter === key ? "active" : ""}`}
            onClick={() => setFilter(key)}
          >
            {label}
            <span className="admin-filter-count">{counts[key]}</span>
          </button>
        ))}
      </div>

      {/* Tarjetas */}
      <div className="admin-cards">
        {filtered.length === 0 ? (
          <div className="admin-empty">
            <p>No hay propuestas en esta categoría.</p>
          </div>
        ) : (
          filtered.map((pitch) => {
            const st = STATUS_LABEL[pitch.status] || STATUS_LABEL.pending;
            const isOpen = expanded === pitch.id;
            return (
              <div key={pitch.id} className="pitch-card">
                <div className="pitch-card-header" onClick={() => setExpanded(isOpen ? null : pitch.id)}>
                  <div className="pitch-card-title-row">
                    <h3 className="pitch-title">{pitch.title}</h3>
                    <span className="pitch-status" style={{ color: st.color }}>
                      ● {st.text}
                    </span>
                  </div>
                  <div className="pitch-meta">
                    <span>👤 {pitch.submittedBy}</span>
                    <span>📅 {new Date(pitch.submittedAt).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" })}</span>
                    <span>🎭 {pitch.genres.join(", ")}</span>
                  </div>
                </div>

                {isOpen && (
                  <div className="pitch-card-body">
                    <p className="pitch-synopsis">{pitch.synopsis}</p>
                    {pitch.comments && (
                      <p className="pitch-comments">💬 {pitch.comments}</p>
                    )}
                    {pitch.status === "pending" && (
                      <div className="pitch-actions">
                        <button className="btn-approve" onClick={() => handleApprove(pitch)}>
                          ✅ Aprobar
                        </button>
                        <button className="btn-reject" onClick={() => handleReject(pitch)}>
                          ❌ Rechazar
                        </button>
                      </div>
                    )}
                  </div>
                )}

                {/* Indicador de expandir */}
                <div className="pitch-expand-hint">{isOpen ? "▲" : "▼"}</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SubmissionsAdmin;
